import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { IOpenUploadStateAction, initialState } from "./initialState";
export const useOpenUploadStore = create<IOpenUploadStateAction>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        openUpload(isAns) {
          isAns
            ? set({
                open: true,
                isAns,
              })
            : set({
                open: true,
              });
        },
        closeUpload() {
          set({
            open: false,
            isAns: false,
          });
        },
      }),
      {
        name: "open-upload-storage",
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
    {
      name: "open-upload-store",
    },
  ),
);
